// extracted by mini-css-extract-plugin
module.exports = {"amount":"Balance_amount__25Fs4"};